/**
 * @generated SignedSource<<50cc9e32326d0ee93f96c735834ea2a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mapElementGeometryId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "mapElementGeometryId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MapElementsVectorGridTooltipQuery",
    "selections": [
      {
        "alias": "mapElementGeometry",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MapElementTooltip",
                "kind": "LinkedField",
                "name": "tooltip",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MapElementGeometry",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MapElementsVectorGridTooltipQuery",
    "selections": [
      {
        "alias": "mapElementGeometry",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MapElementTooltip",
                "kind": "LinkedField",
                "name": "tooltip",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MapElementGeometry",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2bdfc18b4421b407e5e6dffb0950b6b7",
    "id": null,
    "metadata": {},
    "name": "MapElementsVectorGridTooltipQuery",
    "operationKind": "query",
    "text": "query MapElementsVectorGridTooltipQuery(\n  $mapElementGeometryId: ID!\n) {\n  mapElementGeometry: node(id: $mapElementGeometryId) {\n    __typename\n    ... on MapElementGeometry {\n      tooltip {\n        content\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "574f880cb54da11c5decad73ddf5ce7b";

module.exports = node;
